export const eSignConstants = {
  GET_ESIGN_DOCUMENT_REQUEST: 'GET_ESIGN_DOCUMENT_REQUEST',
  GET_ESIGN_DOCUMENT_SUCCESS: 'GET_ESIGN_DOCUMENT_SUCCESS',
  GET_ESIGN_DOCUMENT_FAILURE: 'GET_ESIGN_DOCUMENT_FAILURE',

  GET_ESIGN_LIST_REQUEST: 'GET_ESIGN_LIST_REQUEST',
  GET_ESIGN_LIST_SUCCESS: 'GET_ESIGN_LIST_SUCCESS',
  GET_ESIGN_LIST_FAILURE: 'GET_ESIGN_LIST_FAILURE',

  UPLOAD_FILES_REQUEST: 'UPLOAD_FILES_REQUEST',
  UPLOAD_FILES_SUCCESS: 'UPLOAD_FILES_SUCCESS',
  UPLOAD_FILES_FAILURE: 'UPLOAD_FILES_FAILURE',
};
